import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import { AuthProvider } from "./context/AuthContext";
import Header from "./components/Header";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Courses from "./pages/Courses";
import CourseDetails from "./pages/CourseDetails";
import PrivateRoute from "./components/PrivateRoute";
import Footer from "./components/Footer";
import Admin from "./pages/Admin";
import AdminRoute from './components/AdminRoute';
import Profile from './pages/Profile';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import VerifyEmail from "./pages/VerifyEmail";

function App() {
  const [splashVisible, setSplashVisible] = useState(true);
  return (
    <>
      <ToastContainer />
      <AuthProvider>
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="/" element={<Home setSplashVisible={setSplashVisible} />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/profile/*" element={<PrivateRoute><Profile /></PrivateRoute>} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route
              path="/courses"
              element={
                <PrivateRoute>
                  <Courses />
                </PrivateRoute>
              }
            />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/terminos" element={<Terms />} />
            <Route path="/privacidad" element={<Privacy />} />
            <Route
              path="/courses/:id"
              element={
                <PrivateRoute>
                  <CourseDetails />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <PrivateRoute>
                  <AdminRoute>
                    <Admin />
                  </AdminRoute>
                </PrivateRoute>
              }
            />
          </Routes>
          {!splashVisible && <Footer />}
        </BrowserRouter>
      </AuthProvider>
    </>
  );
}

export default App;
